/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConversionProjectionDtoFramedResultDto } from '../models/ConversionProjectionDtoFramedResultDto';
import type { ConvertDto } from '../models/ConvertDto';
import type { CreateQuoteDto } from '../models/CreateQuoteDto';
import type { CustomerConversionSettingDto } from '../models/CustomerConversionSettingDto';
import type { CustomerQuote } from '../models/CustomerQuote';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class OtcTradingService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns CustomerQuote Created
     * @throws ApiError
     */
    public postV1OtcTradingQuoteRequests(
        requestBody?: CreateQuoteDto,
    ): CancelablePromise<CustomerQuote> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/otc-trading/quote-requests',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CustomerQuote Created
     * @throws ApiError
     */
    public postV1OtcTradingGuestQuoteRequests(
        requestBody?: CreateQuoteDto,
    ): CancelablePromise<CustomerQuote> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/otc-trading/guest-quote-requests',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns number Created
     * @throws ApiError
     */
    public postV1OtcTradingConversions(
        requestBody?: ConvertDto,
    ): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/otc-trading/conversions',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param page
     * @param count
     * @returns ConversionProjectionDtoFramedResultDto Success
     * @throws ApiError
     */
    public getV1OtcTradingConversions(
        page: number = 1,
        count: number = 100,
    ): CancelablePromise<ConversionProjectionDtoFramedResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/otc-trading/conversions',
            query: {
                'page': page,
                'count': count,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @returns CustomerConversionSettingDto Success
     * @throws ApiError
     */
    public getV1OtcTradingSettings(): CancelablePromise<CustomerConversionSettingDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/otc-trading/settings',
            errors: {
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public putV1OtcTradingSettings(
        requestBody?: CustomerConversionSettingDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/otc-trading/settings',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
}
